import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';

export const paymentApprovalsHandler: RestHandler[] = [
  rest.post(PATHS.getApCheckApprovalsPath('*'), (_, res, ctx) =>
    res(ctx.status(200), ctx.body(''))
  )
];

export const authorizedApCheckHandler: RestHandler[] = [
  rest.post(PATHS.getPrintIsAuthorizedPath('*'), (_, res, ctx) =>
    res(ctx.status(200), ctx.body(''))
  )
];

export const deleteApprovalHandler: RestHandler[] = [
  rest.delete(PATHS.getApCheckApprovalsPath('*'), (_, res, ctx) =>
    res(ctx.status(204), ctx.body(''))
  )
];
